<template>
  <!-- <div class="new-order-wrapper"> -->
  <div class="grid-responsive" style="width: 100%">
    <div class="grid">
      <div
        v-for="(item, i) in staffs"
        :key="item.id"
        class="grid-item"
        :style="{
          backgroundColor:
            currentIndex === i && highlight
              ? '#b4ded5'
              : $store.getters.printStaffColor(item),
        }"
        @click="handleClickItem(item, i)"
      >
        {{ item.ref }}<br />
      </div>
      <div class="text-result" v-if="!staffs.length" v-translate>
        No results found!
      </div>
    </div>
  </div>
  <!--   </div> -->
</template>

<script>
export default {
  name: "GridView",
  props: {
    items: { type: Array, default: () => [] },
    highlight: { type: Boolean, default: false },
    type: { type: String, default: "" },
  },
  data() {
    return {
      currentIndex: null,
    };
  },
  computed: {
    staffPage() { return this.getMap('staffPage', true) },
    staffs() {
      return this.getArray("staffs")
        .filter((staff) => {
          return (
            (this.isRole(staff.subRoles, "Order taker / Staff / Waitress") ||
              this.isRole(staff.subRoles, "Other Staff")) &&
            (this.staffPage == null ||
              (staff.location == this.user.location.id) == this.staffPage)
          );
        })
        .sort((a, b) => a.ref - b.ref);
    },
    staffMap() {
      return this.$store.state.staff.staffs;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    this.$store.state.staff.staffPage = true;
  },
  methods: {
    isRole(items, key) {
      let flag = false;
      items.forEach((item) => {
        let role = this.getObject(item, "roles");
        if (role && role.name == key) flag = true;
      });
      return flag;
    },
    handleClickItem(item, index) {
      //this.currentIndex = index;
      this.$emit("pickStaff", item);
    },
  },
};
</script>
